var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.7,
    height: 22.7,
    viewBox: "0 0 22.7 22.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(-1.15 -1.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    d: "M10.5-.85A11.35,11.35,0,0,1,21.85,10.5,11.35,11.35,0,0,1,2.474,18.526a11.35,11.35,0,0,1,0-16.051A11.276,11.276,0,0,1,10.5-.85Zm0,21A9.65,9.65,0,1,0,.85,10.5,9.661,9.661,0,0,0,10.5,20.15Z",
    transform: "translate(0 -0.001)",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M9,16.15A.85.85,0,0,1,8.4,14.7l6.3-6.3a.85.85,0,0,1,1.2,1.2L9.6,15.9A.847.847,0,0,1,9,16.15Z",
    transform: "translate(-1.65 -1.65)",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M15.3,16.15a.847.847,0,0,1-.6-.249L8.4,9.6A.85.85,0,0,1,9.6,8.4l6.3,6.3a.85.85,0,0,1-.6,1.451Z",
    transform: "translate(-1.65 -1.65)",
    fill: "#A5A5A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.c6d2481383e82fafb8e5634885b7b1d2.svg";
export { ForwardRef as ReactComponent };